import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './word-search-puzzle.actions';
import { patch } from '@ngxs/store/operators';
import { WordSearchPuzzleStateModel } from './word-search-puzzle-state.model';
import { Injectable } from '@angular/core';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';
// @dynamic
@State<WordSearchPuzzleStateModel>({
  name: 'wordSearchPuzzleState',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class WordSearchPuzzleState extends PuzzleGameBaseState {
  @Action(actions.InitWordSearchPuzzle)
  InitImagePuzzleGame(state: StateContext<WordSearchPuzzleStateModel>, { payload }: actions.InitWordSearchPuzzle) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistWordSearchState)
  PersistImagePuzzleState(
    state: StateContext<WordSearchPuzzleStateModel>,
    { payload }: actions.PersistWordSearchState
  ) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            words: payload.words,
          }),
        }),
      })
    );
  }
}
